const initState = {
  regError: null,
  usernameDup: null,
  progressUpdateCompleted: null,
  usernameError: null,
  passwordError: null,
};

const regReducer = (state = initState, action) => {
  switch (action.type) {
    case "REG_ERROR_PASSWORD_RESET":
      return {
        ...state,
        passwordError: null,
      };
    case "REG_ERROR_PASSWORD_TOO_SHORT":
      return {
        ...state,
        passwordError: "PASSWORD_FORM_TOO_SHORT",
      };
    case "REG_ERROR_USERNAME_RESET":
      return {
        ...state,
        usernameError: null,
      };
    case "REG_ERROR_USERNAME_TOO_LONG":
      return {
        ...state,
        usernameError: "USERNAME_FORM_TOO_LONG",
      };
    case "REG_ERROR_USERNAME_TOO_SHORT":
      return {
        ...state,
        usernameError: "USERNAME_FORM_TOO_SHORT",
      };
    case "REG_ERROR_USERNAME_USED":
      return {
        ...state,
        usernameError: "USERNAME_FROM_ALREADY_TAKEN",
      };
    case "CHECK_DUPLICATE_USERNAME_FALSE":
      return {
        ...state,
        regError: null,
        usernameDup: action.result,
      };
    case "CHECK_DUPLICATE_USERNAME_TRUE":
      return {
        ...state,
        regError: null,
        usernameDup: action.result,
      };
    case "CHECK_DUPLICATE_USERNAME_ERROR":
      return {
        ...state,
        regError: "Checking duplication is failed.",
        usernameDup: null,
      };
    case "PROGRESS_UPDATE_SUCCESS":
      return {
        ...state,
        regError: null,
        usernameDup: null,
        progressUpdateCompleted: true,
      };
    case "PROGRESS_UPDATE_ERROR":
      return {
        ...state,
        regError: action.err,
        usernameDup: null,
        progressUpdateCompleted: null,
      };
    case "RESET_PROGRESS_VAR":
      return {
        ...state,
        progressUpdateCompleted: null,
      };
    default:
      return state;
  }
};

export default regReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/regReducers.tsx